<template>
  <ui-select
    v-model="value"
    :items="data"
    item-text="title"
    item-value="value"
    :autocomplete="false"
    prepend-inner-icon="fas fa-bars"
    :hide-details="1"
  ></ui-select>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import query from '@/components/query/query-constructor';
import { useStore } from '@/store';
import { sortByPickerData } from './base/utils';

const store = useStore();
const route = useRoute();
const param = 'orderBy';

const data = sortByPickerData().map((item) => ({
  value: item.pickerValue,
  title: item.title,
}));

const value = ref('reports-profit');

const resolveDefaultValue = () => {
  const group = store.user.dashboardDefaultGroup || '';
  const val = group.includes('conversion') ? 'conversion' : group;
  return (data.find((item) => item.value.includes(val)) || { value: '' }).value || 'reports-profit';
};

const syncTemporaryQuery = (pick: boolean, nextValue?: string) => {
  let resolvedValue = nextValue ?? value.value;
  if (pick) {
    const cacheUrl = query.decode(route.params.data as string) || {};
    const cacheStore = store.dashboardQuery;
    resolvedValue = (cacheUrl[param] as string) || resolvedValue || (cacheStore[param] as string);
    value.value = resolvedValue;
  }
  store.patchDashboardQueryTemporaryField({ name: param, value: resolvedValue });
};

const updateSortBy = (val: string) => {
  const sorting = data.find((item) => item.value === val) || data[0];
  store.dashboardSortBy = { title: sorting.title, value: sorting.value };
};

onMounted(() => {
  syncTemporaryQuery(true, resolveDefaultValue());
  updateSortBy(value.value);
});

watch(value, (val) => {
  if (!data.find((item) => item.value === val)) {
    value.value = (data.find((item) => item.value.includes(val)) || { value: '' }).value || 'reports-profit';
    return;
  }

  const sorting = data.find((item) => item.value === val) || data[0];
  syncTemporaryQuery(false, sorting.value);
  updateSortBy(val);
});
</script>
